import { render, staticRenderFns } from "./integrations-list.vue?vue&type=template&id=ad31ddbe"
import script from "./integrations-list.vue?vue&type=script&lang=js"
export * from "./integrations-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports